import { jsx } from "react/jsx-runtime";
import {
  DSFormLayoutBlockItem
} from "@elliemae/ds-form-layout-blocks";
const DSFormLayoutBlockItemWithValidation = ({ fieldState, children, ...props }) => {
  return /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      hasError: fieldState.invalid,
      validationMessage: fieldState.error?.message,
      ...props,
      children
    }
  );
};
export {
  DSFormLayoutBlockItemWithValidation
};
